import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import platformAPI from "../../../services/platformApi";
import PlatformPageHeader from "./PlatformPageHeader";
import s from "./platformAdmin.module.css";

export default function PlatformOnboardingEmails() {
  const [emails, setEmails] = useState([]);
  const [active, setActive] = useState("");
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  useEffect(() => {
    platformAPI
      .getOnboardingEmailPreviews()
      .then((data) => {
        const list = data.emails || [];
        setEmails(list);
        setActive(list[0]?.key || "");
      })
      .catch((e) =>
        setErr(e.response?.data?.error || "Не удалось загрузить письма"),
      )
      .finally(() => setLoading(false));
  }, []);

  const current = emails.find((item) => item.key === active) || emails[0];

  return (
    <div className={s.page}>
      <PlatformPageHeader
        title="Письма онбординга"
        lead="Цепочка для владельца клуба на пробном периоде. Отправляются автоматически."
        actions={
          <Link to="/admin/leads" className={s.heroActionBtnGhost}>
            ← К лидам
          </Link>
        }
      />

      {err ? <div className={s.alertError}>{err}</div> : null}
      {loading ? <div className={s.loading}>Загрузка…</div> : null}

      {!loading && emails.length ? (
        <>
          <div className={s.clubsFilterChips} role="tablist">
            {emails.map((item) => (
              <button
                key={item.key}
                type="button"
                role="tab"
                aria-selected={active === item.key}
                className={`${s.clubsFilterChip} ${
                  active === item.key ? s.clubsFilterChipActive : ""
                }`}
                onClick={() => setActive(item.key)}
              >
                {item.label}
              </button>
            ))}
          </div>

          {current ? (
            <section className={s.exportPanel}>
              <div className={s.exportPanelHead}>
                <div>
                  <h2 className={s.exportPanelTitle}>{current.label}</h2>
                  <p className={s.exportPanelLead}>
                    <strong>Тема:</strong> {current.subject}
                  </p>
                </div>
              </div>
              <iframe
                title={current.subject}
                srcDoc={current.html}
                className={s.onboardingEmailPreview}
              />
            </section>
          ) : null}
        </>
      ) : null}
    </div>
  );
}
